import React, { useContext, useEffect } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaVimeo,
} from "react-icons/fa";
import { DataContext } from "../../context/DataContext";
import { SocialMediaUrl } from "../../types/strapi";

interface FooterTwoProps {
  setToTop?: (value: number) => void;
  toTop?: number;
}

const FooterTwo: React.FC<FooterTwoProps> = ({ setToTop, toTop }) => {
  const currentYear = new Date();
  const context = useContext(DataContext);
  const socialMedia = context?.socialMedia || [];

  const disableCarousel = () => {
    const footerElement = document.querySelector(".footer-style-2");

    if (footerElement && footerElement instanceof HTMLElement) {
      if (window.scrollY > footerElement.offsetTop - 500 && toTop === 0) {
        setToTop?.(1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", disableCarousel);

    return () => {
      window.removeEventListener("scroll", disableCarousel);
    };
  }, [setToTop, toTop]);

  return (
    <div className="footer-style-2 ptb--30 bg_color--6">
      <div className="wrapper plr--50 plr_sm--20">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="inner" />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="inner text-center">
              <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                {socialMedia.map((val: SocialMediaUrl, i: number) => (
                  <li key={i}>
                    {val.url.indexOf("behance") !== -1 ? (
                      ""
                    ) : (
                      <a
                        href={`${val.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {val.url.indexOf("facebook") !== -1 ? (
                          <FaFacebookF />
                        ) : (
                          ""
                        )}
                        {val.url.indexOf("instagram") !== -1 ? (
                          <FaInstagram />
                        ) : (
                          ""
                        )}
                        {val.url.indexOf("linkedin") !== -1 ? (
                          <FaLinkedinIn />
                        ) : (
                          ""
                        )}
                        {val.url.indexOf("twitter") !== -1 ? <FaTwitter /> : ""}
                        {val.url.indexOf("vimeo") !== -1 ? <FaVimeo /> : ""}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
              <div className="text mt--20">
                <p>{`Copyright © ${currentYear.getFullYear()} CEM. All Rights Reserved.`}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12 col-12">
            <div className="inner text-lg-right text-center mt_md--20 mt_sm--20" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterTwo;
